export default __webpack_public_path__ + "static/media/lawnWork.d280cadc.jpg";